/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';
import * as actions from '../redux/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import HomeBanners from '../HomeBanners';
import getSlides from '../functions/getSlides/getSlides';
import ThemeNineSearchBox from './common/ThemeNineSearchBox';
import getIcons from '../functions/getIcons/getIcons';
import ThemeNineTitle from './common/ThemeNineTitle';
import { KuposInput, KuposModal, SvgHome } from '../../common';
import MultiSlider3 from '../common/MultiSlider/MultiSlider3';

const serviceItems = [
  { icon: 'service1', title: 'Servicios especiales' },
  { icon: 'service2', title: 'Servicios de envíos' },
];

const precationItems = [
  { icon: 'precaution1', title: 'Buses <br/> sanitizados' },
  { icon: 'precaution2', title: 'Contamos con alcohol gel' },
  { icon: 'precaution3', title: 'No dejes de usar tu mascarilla' },
  { icon: 'precaution4', title: 'Mantener la distancia social recomendada' },
];
const createMarkup = data => {
  return {
    __html: data,
  };
};

const renderServiceSection = () => {
  return (
    <div className="service-container">
      <ThemeNineTitle title={'¡También te ofrecemos!'} />
      <div className="service-items">
        {serviceItems.map(item => {
          return (
            <div className="service-item bold-text">
              <img src={getIcons(item.icon)} alt="" />
              <span className="title font11 upper-case">{item.title}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const renderPrecationSection = () => {
  return (
    <div className="precaution-items">
      {precationItems.map(item => {
        return (
          <div className="precaution-item">
            <div>
              <img src={getIcons(item.icon)} alt="" />
            </div>
            <div
              className="title bold-text font13"
              dangerouslySetInnerHTML={createMarkup(item.title)}
            ></div>
          </div>
        );
      })}
    </div>
  );
};

const ThemeNine = ({ history, operator }) => {
  useEffect(() => {
    const scriptTag = document.createElement('script');
    scriptTag.src = 'https://apps.elfsight.com/p/platform.js';
    scriptTag.async = true;

    document.body.appendChild(scriptTag);
    return () => {
      document.body.removeChild(scriptTag);
    };
  }, []);

  const [pnrPopup, setPnrPopup] = useState(false);
  return (
    <div className="theme-five theme-nine theme-seven theme-four">
      <div style={{ position: 'relative' }}>
        <div>
          <HomeBanners
            slides={getSlides('Banner', operator)}
            // height={'87vh'}
            activeDotColor={operator && operator.color_codes && operator.color_codes.button_color}
          />
        </div>
        <div className="searchboxoverlay">
          <ThemeNineSearchBox history={history} operator={operator} />
        </div>
      </div>
      {operator && operator.name == 'busesahumada' && (
        <div
          style={{ marginTop: 20 }}
          onClick={() => {
            history.push('/frequent-passengers');
          }}
        >
          <img src={getIcons('studentBanner')} alt="" />
        </div>
      )}
      {renderServiceSection()}

      <div className="destination-section" style={{ width: '80%', margin: 'auto' }}>
        <ThemeNineTitle title={'¡Conoce nuestros destinos!'} />
        {/* <ThemeNineSlider slides={getSlides('Destination', operator)} destinoTitle /> */}
        <MultiSlider3
          multiSlides={getSlides('Destination', operator)}
          removeArrowOnDeviceType={[]}
          andrimarArrowStyle
          operator={operator}
        />
      </div>

      <div className="precautions-section main-container">
        <ThemeNineTitle title={'Nuestras medidas de prevención de COVID-19'} />
        {renderPrecationSection()}

        {operator && operator.operator_name == 'busesahumada' && (
          <div className="precautions-button" onClick={() => setPnrPopup(!pnrPopup)}>
            VER MÁS
          </div>
        )}
      </div>

      <div className="company-section">
        <img src={getIcons('companyBG')} />
        <div className="video-and-form-section">
          {/* <div className="video-item">
            <ThemeNineTitle title={'Conoce nuestra historia'} />
            <div className="company-video">
              <video width="100%" controls>
                <source src={getIcons('companyVideo')} type="video/mp4" />
              </video>
            </div>
          </div> */}
          <div className="video-item">
            <ThemeNineTitle title={'Contáctanos'} whiteHeading />
            <div className="contact-us d-flex">
              <div className="form-section" style={{ maxWidth: '50vw' }}>
                <div className="contact-input-item">
                  <div className="contact-input-label less-bold-text font11">Nombre</div>
                  <KuposInput
                    type="text"
                    placeholder="Ej. Pedro"
                    inputOuterStyle={{ border: '1px solid #cccc' }}
                    className={'input-theme-nine'}
                  />
                </div>

                <div className="contact-input-item ">
                  <div className="contact-input-label less-bold-text font11">Teléfono</div>
                  <KuposInput
                    type="text"
                    placeholder="+56 9 0000 0000"
                    inputOuterStyle={{ border: '1px solid #cccc' }}
                    className={'input-theme-nine'}
                  />
                </div>

                <div className="contact-input-item">
                  <div className="contact-input-label less-bold-text font11">Email</div>
                  <KuposInput
                    type="email"
                    placeholder="ejemplo@gmail.com"
                    inputOuterStyle={{ border: '1px solid #cccc' }}
                    className={'input-theme-nine'}
                  />
                </div>

                <div className="contact-input-item">
                  <div className="contact-input-label less-bold-text font11">Comentario</div>
                  <KuposInput
                    type="text"
                    placeholder="Opcional"
                    inputOuterStyle={{ border: '1px solid #cccc' }}
                    className={'input-theme-nine'}
                  />
                </div>

                {/* <style>
          .btn:hover{'{'}
          background: #e84b3f !important;
        </style> */}

                <div className="contact-input-item center ">
                  <button
                    class="btn submit-btn  bold-text"
                    style={{
                      background:
                        operator &&
                        operator.color_codes &&
                        operator.color_codes.button_color &&
                        operator.color_codes.button_color,
                      color: 'white',
                      width: '100%',
                    }}
                  >
                    ENVIAR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <KuposModal
        ariaLabel="tnc-pnr-modal-outer"
        size={pnrPopup ? 'lg' : 'xl'}
        onHide={() => setPnrPopup(!pnrPopup)}
        showModal={pnrPopup}
      >
        <div className="tnc-pnr-modal">
          {pnrPopup && (
            <video width="100%" controls>
              <source src={getIcons('companyVideo')} type="video/mp4" />
            </video>
          )}
          <div className="close-button pointer" onClick={() => setPnrPopup(!pnrPopup)}>
            <SvgHome name="close" />
          </div>
        </div>
      </KuposModal>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeNine);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNine.js